import { useCallback } from "react";
export function useSetFieldError(setError, setFocus) {
  return useCallback(
    (fieldName, message) => {
      setError(fieldName, { type: "manual", message });
      setFocus(fieldName);
    },
    [setError, setFocus],
  );
}
